// extracted by mini-css-extract-plugin
export default {"primary":"Button_primary__sUhZI","secondary":"Button_secondary__1kii4"};